import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';

const slice = createSlice({
	name: 'loans',
	initialState: {
		list: null,
		loading: false,
		lastFetch: null,
		updated: false,
		searchText: '',
		noLoans: false,
		signers: {},
	},
	reducers: {
		loansRequestFailed: (loans, action) => {
			loans.loading = false;
			loans.noLoans = true;
		},
		loansRequested: (loans, action) => {
			loans.loading = true;
		},
		loansReceived: (loans, action) => {
			loans.list = action.payload.data;
			if (action.payload.data.length === 0) loans.noLoans = true;
			else loans.noLoans = false;
			loans.loading = false;
			loans.lastFetch = Date.now();
			loans.updated = false;
		},
		loansAdded: (loans, action) => {
			loans.list.unshift(action.payload);
			loans.updated = true;
			loans.noLoans = false;
		},
		loansDeleted: (loans, action) => {
			console.log(action.payload);
			const index = loans.list.findIndex(s => s.id === action.payload.deletedId);
			loans.list.splice(index, 1);
			loans.updated = true;
			if (loans.list.length === 0) loans.noLoans = true;
		},
		loansUpdated: (loans, action) => {
			const index = loans.list.findIndex(s => s.id === action.payload.id);
			loans.list[index] = action.payload;
			loans.updated = true;
			loans.noLoans = false;
		},
		searchTextChanged: (loans, action) => {
			loans.searchText = action.payload;
		},
		loansRelated: (loans, action) => {
			loans.updated = true;
		},
		updateSigners: (loans, { payload }) => {
			loans.signers[payload.key] = payload.values;
		},
	},
});

export const {
	loansAdded,
	loansReceived,
	loansRequested,
	loansRequestFailed,
	searchTextChanged,
	loansUpdated,
	loansDeleted,
	loansRelated,
	updateSigners,
} = slice.actions;

export const loadLoans =
	(type = 'user', page = 1, per_page = 10) =>
	(dispatch, getState) => {
		const user = getState().auth.user;

		dispatch(
			apiCallBegan({
				api: 'hammurabi',
				url: '/loans',
				params: {
					type,
					user_id: user.id,
					page,
					per_page,
				},
				onStart: loansRequested.type,
				onSuccess: loansReceived.type,
				onError: loansRequestFailed.type,
			})
		);
	};

export default slice.reducer;
